import types from "../actionTypes";

export default (
  state = {
    filterApplicationValues: [],
  },
  action
) => {
  switch (action.type) {
    case types.SET_FILTER_APPLICATION_VALUES:
      return Object.assign({}, state, { filterApplicationValues: action.value });
    default:
      return state;
  }
};
